module.exports = __webpack_public_path__ + "media/icons/subtraction-2ba8e62a.png";